/* FizzyIQ — Science "Why we exist" explorer (scw-). Left-nav tabs swap the
   right detail panel. Re-adds .is-active so the panel's CSS entrance replays. */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.scwInit === '1') return;
    root.dataset.scwInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.scw-nav-btn[data-scw]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.scw-panel[data-scw-panel]'));
    if (!tabs.length || !panels.length) return;

    function select(i) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-scw') === String(i);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-scw-panel') === String(i);
        if (on) {
          p.hidden = false;
          // restart the entrance animation
          p.classList.remove('is-active');
          void p.offsetWidth;
          p.classList.add('is-active');
        } else {
          p.classList.remove('is-active');
          p.hidden = true;
        }
      });
    }

    tabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { select(tab.getAttribute('data-scw')); });
      // Roving arrow-key navigation across the tablist.
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
                : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = (idx + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        select(tabs[next].getAttribute('data-scw'));
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.scw'), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    var root = e.target.querySelector('.scw');
    if (root) initSection(root);
  });
})();
